export const BrandColors = {
  BACKGROUND_PRIMARY: "#F1F2F3",
  BACKGROUND_SECONDARY: "#262624",
  BACKGROUND_TERNARY: "#444441",
  BACKGROUND_RED: "#E6052E",
  BACKGROUND_FLAG_LOADER: "#777777",
  BORDER_PRIMARY: "#4C4B59",
  BORDER_SECONDARY: "#303030",
  BORDER_TEAM_QUALIFIED: "#00C643",
  TEXT_PRIMARY: "#FFFFFF",
  TEXT_SECONDARY: "#B6B5BD",
  TEXT_TERNARY: "#FAFAFF",
  WHITE: "#FFF",
  BLACK: "#000",

  /* Surfaces */
  SURFACE_OPTION: "#fefefe",
  SURFACE_ALT: "#fafafa",
  SURFACE_MUTED: "#ebebeb",
  SURFACE_LIGHT: "#cbcbcb",

  /* Text / dark */
  TEXT_TITLE: "#0f1014",
  DARK_900: "#161616",
  DARK_800: "#1a1a1a",
  DARK_700: "#1b2024",
  DARK_600: "#2f3438",
  DARK_500: "#3d3d3d",

  /* Greens */
  GREEN: "#008001",
  GREEN_DARK: "#006601",
  GREEN_LIGHT: "#1ebf00",
  GREEN_MEDIUM: "#52ae52",
  GREEN_FOREST: "#1a7a3c",

  /* Grays */
  GRAY_700: "#4a4a4a",
  GRAY_600: "#515a61",
  GRAY_500: "#5a5a5a",
  GRAY_400: "#9ba4ac",
  GRAY_300: "#b0b0b0",
  GRAY_200: "#d5d9dc",

  /* Reds */
  RED: "#e7000b",
  RED_DARK: "#cf1a17",
  RED_BRIGHT: "#f33540",

  /* Accents */
  NAVY: "#00205c",
  PURPLE: "#4a148c",
  VIOLET: "#6200ea",
  YELLOW: "#facd05",
  YELLOW_AMBER: "#ffe040",
} as const;
